import React, { useEffect, useState } from "react";
import styles from "./Style.module.css";
import {
  Avatar,
  Button,
  ButtonBase,
  CircularProgress,
} from "@material-ui/core";
import { Add, Edit } from "@material-ui/icons";
import DeleteDialog from "./component/DeleteDialog/DeleteDialog";
import useGroupDetailHook from "./GroupDetail.hook";
import EmployeeCards from "./component/EmployeePage/EmployeeCard";
import CoAdminView from "../CoAdmin/CoAdmin.view";

function GroupDetail({
  groupId,
  handleUpdateGroup,
  handleClosepopOver,
  isGroupAdmin,
  coAdminDialog,
  toggleCoAdminDialog,
  fetchChatInfo,
  isAuditAdmin,
  isAdminCoAdmin,
  renderConversation
}) {
  const {
    handleExit,
    exitDialog,
    toggleExitDialog,
    data,
    isLoading,
    empId,
    getCoAdminIDs,
  } = useGroupDetailHook({
    groupId,
    handleUpdateGroup,
    handleClosepopOver,
    renderConversation
  });

  if (isLoading) {
    return (
      <div className={styles.circularWrap}>
        <CircularProgress />
      </div>
    );
  }
  return (
    <div className={styles.containerWrap21}>
      <DeleteDialog
        isOpen={exitDialog}
        handleToggle={toggleExitDialog}
        handleSubmit={handleExit}
        key={"Exit"}
        exitMember
        empId={empId}
      />
      {coAdminDialog ? (
        <CoAdminView
          empList={data?.employees || []}
          groupId={groupId}
          coAdminIds={getCoAdminIDs || []}
          handleUpdateGroup={handleUpdateGroup}
          handleClosepopOver={handleClosepopOver}
          fetchChatInfo={fetchChatInfo}
          renderConversation={renderConversation}
        />
      ) : (
        <>
          <div>
            <div className={styles.editBtn2}>
              <div className={styles.avatarWrap}>
                {data?.display_type === "INITIALS" ? (
                  <Avatar className={styles.avatarClass}>
                    {data?.initials?.slice(0, 2)}
                  </Avatar>
                ) : (
                  <img src={data?.image} className={styles.img} />
                )}
                <div className={styles.title}>{data?.name}</div>
              </div>
              {isGroupAdmin && (
                <ButtonBase
                  className={styles.edit}
                  onClick={() => handleUpdateGroup("UPDATE")}
                >
                  EDIT
                  <Edit style={{ fontSize: ".8rem", marginLeft: "5px" }} />
                </ButtonBase>
              )}
            </div>
          </div>
          <div>
            <div className={styles.title}>Description</div>
            <div className={styles.des21}>{data?.description}</div>
          </div>
          <div>
            <div className={styles.title}>Group Permissions</div>
            <div className={styles.des21}>
              {data?.is_close_group
                ? " Only admins can send messages"
                : "All participants can send messages"}
            </div>
          </div>
          {data?.group_type !== "NONE" && (
            <div>
              <div className={styles.title}>Filter Members By</div>
              <div className={styles.des21}>
                {data?.group_type}
                <br />
              </div>
              <div className={styles.des21Grp}>
                {data?.groupRef?.map((val) => val?.label)?.join(" , ")}
              </div>
            </div>
          )}
          <div>
            <div className={styles.coAdminWrap}>
              <div className={styles.title}>Group Member</div>
              {(isAdminCoAdmin || isAuditAdmin || isGroupAdmin) && (
                <div className={styles.btnWrap}>
                  <ButtonBase
                    onClick={toggleCoAdminDialog}
                    className={styles.coAdminBtn}
                  >
                    ADD CO-ADMIN{" "}
                    <Add fontSize={"small"} className={"plusIcon"}></Add>
                  </ButtonBase>
                </div>
              )}
            </div>

            <div className={styles.des21}>
              <div className={styles.card}>
                <EmployeeCards
                  data={data}
                  isGroupAdmin={isGroupAdmin}
                  toggleExitDialog={toggleExitDialog}
                  coAdminIds={getCoAdminIDs}
                  isAdminCoAdmin={isAdminCoAdmin}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default GroupDetail;
